import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

export const Header = styled.div`
  display: flex;
  padding: 12px 16px;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  flex: 1 0 0;
  align-self: stretch;
  border-top: 1px solid ${themeGet('colors.black.10')};
  border-bottom: 1px solid ${themeGet('colors.black.10')};
`;

export const TopHeader = styled(Header)`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  border-radius: 8px 8px 0px 0px;
  border-top: none;
  border-bottom: 1px solid ${themeGet('colors.black.10')};
  min-height: 70px;
  align-items: center;
`;
